import { createAsyncThunk } from '@reduxjs/toolkit';
import { alarmSummary } from "../../config/services/ApiServices"; 

export const fetchAlarmSummary = createAsyncThunk('alarm-summary/fetch', async ({ customerId, productType, pageNo, pageSize }: {
  customerId: string, productType: string, pageNo: number, pageSize: number
}) => {

  const response = await alarmSummary({ customerId, productType, pageNo, pageSize });
  return response;
});